import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';
import { iconsList } from '../icon/glyphs';
import { TYPES } from './constants';
import getIconType from './helpers/get-icon-type';

const SolidIcon = ({ glyph, type = TYPES.default, size = 24, strokeWidth = 1.3 }) => {
  const classes = classNames('ws-ui-solid-icon', `ws-ui-solid-icon--${type}`);
  const iconType = getIconType(type);

  return (
    <div className={classes}>
      <Icon glyph={glyph} type={iconType} size={size} strokeWidth={strokeWidth} />
    </div>
  );
};

SolidIcon.propTypes = {
  glyph: PropTypes.oneOf(iconsList).isRequired,
  type: PropTypes.oneOf(Object.values(TYPES)),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeWidth: PropTypes.number,
};

export default SolidIcon;
